"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var d3_1 = require("d3");
var line_1 = require("./line");
var Area = /** @class */ (function (_super) {
    tslib_1.__extends(Area, _super);
    function Area() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.areaStyle = {
            fillOpacity: 0.3,
        };
        return _this;
    }
    Area.prototype.style = function (cfg) {
        this.areaStyle = tslib_1.__assign(tslib_1.__assign({}, this.areaStyle), cfg);
        return this;
    };
    /**
     * 绘制折线图
     * @since 2.0
     */
    Area.prototype.drawSeries = function () {
        var e_1, _a, e_2, _b;
        var _this = this;
        var _c = this.ctx, classPrefix = _c.classPrefix, id = _c.id;
        var smooth = this.options.smooth;
        var series = this.model.getSerieNames();
        var categories = this.model.getCategoryNames();
        var categoryScale = this.categoryScale;
        var serieCls = classPrefix + "-chart-series " + classPrefix + "-chart-line-series";
        var markersCls = classPrefix + "-chart-markers " + classPrefix + "-chart-line-series";
        var shape = this;
        this.seriesGroup.selectAll("g").remove();
        var datum = {};
        try {
            for (var series_1 = tslib_1.__values(series), series_1_1 = series_1.next(); !series_1_1.done; series_1_1 = series_1.next()) {
                var serieName = series_1_1.value;
                datum[serieName] = [];
                try {
                    for (var categories_1 = (e_2 = void 0, tslib_1.__values(categories)), categories_1_1 = categories_1.next(); !categories_1_1.done; categories_1_1 = categories_1.next()) {
                        var cat = categories_1_1.value;
                        var value = shape.model.get(cat, serieName);
                        var x = categoryScale(cat);
                        var y = shape.valueScale(value);
                        var color = shape.colorScale(serieName);
                        datum[serieName].push({ value: value, x: x, y: y, color: color });
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (categories_1_1 && !categories_1_1.done && (_b = categories_1.return)) _b.call(categories_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (series_1_1 && !series_1_1.done && (_a = series_1.return)) _a.call(series_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.seriesGroup
            .selectAll("." + serieCls)
            .data(series)
            .join("g")
            .attr("class", function (_, i) { return serieCls + " " + classPrefix + "-chart-series-" + i; })
            .attr("data-z-index", function (_, i) { return series.length - i - 1; })
            .attr("clip-path", "url(#" + id + ")")
            .call(function (g) {
            var _a = _this, valueScale = _a.valueScale, model = _a.model, areaStyle = _a.areaStyle;
            var connectNulls = _this.ctx.getOption("connectNulls").enable;
            var colorAttrCallback = _this.colorAttrCallback;
            g.each(function serie(serieName) {
                var serieGroup = d3_1.select(this);
                var data = datum[serieName];
                var defaultColor = colorAttrCallback
                    ? colorAttrCallback(data)
                    : data && data[0] && data[0].color;
                // 绘制可见折线
                serieGroup
                    .append("path")
                    .attr("fill", "none")
                    .attr("class", classPrefix + "-chart-shape-missing")
                    .attr("data-z-index", "1")
                    .attr("stroke", defaultColor)
                    .attr("stroke-width", shape.shapeSize)
                    .attr("stroke-linejoin", "round")
                    .attr("stroke-linecap", "round")
                    .attr("d", function () {
                    var lineGenerator = d3_1.line().defined(function (_a) {
                        var value = _a.value;
                        return connectNulls ? true : typeof value === "number";
                    });
                    if (smooth) {
                        lineGenerator.curve(d3_1.curveCatmullRom.alpha(0.3));
                    }
                    return lineGenerator.x(function (_a) {
                        var x = _a.x;
                        return x;
                    }).y(function (_a) {
                        var y = _a.y;
                        return y;
                    })(connectNulls
                        ? data.filter(function (_a) {
                            var value = _a.value;
                            return typeof value === "number";
                        })
                        : data);
                });
                // 绘制面积
                serieGroup
                    .append("path")
                    .attr("fill", "none")
                    .attr("class", classPrefix + "-chart-shape-missing")
                    .attr("data-z-index", "1")
                    .attr("fill", defaultColor)
                    .attr("fill-opacity", areaStyle.fillOpacity)
                    .attr("stroke-linejoin", "round")
                    .attr("stroke-linecap", "round")
                    .attr("d", function () {
                    var lineGenerator = d3_1.area().defined(function (_a) {
                        var value = _a.value;
                        return connectNulls ? true : typeof value === "number";
                    });
                    if (smooth) {
                        lineGenerator.curve(d3_1.curveCatmullRom.alpha(0.3));
                    }
                    var _a = tslib_1.__read(model.getExtent(), 1), min = _a[0];
                    return lineGenerator
                        .x(function (_a, i) {
                        var x = _a.x;
                        var offsetX = shape.shapeSize === 0 ? 0 : shape.shapeSize / 2;
                        if (i === 0)
                            return x - offsetX;
                        if (i === data.length - 1)
                            return x + offsetX;
                        return x;
                    })
                        .y1(function () { return valueScale(min); })
                        .y0(function (_a) {
                        var y = _a.y;
                        return y;
                    })(connectNulls
                        ? data.filter(function (_a) {
                            var value = _a.value;
                            return typeof value === "number";
                        })
                        : data);
                });
                // 绘制追踪线
                serieGroup
                    .append("path")
                    .attr("fill", "none")
                    .attr("class", classPrefix + "-chart-tracker-line")
                    .attr("data-z-index", "2")
                    .attr("stroke", "rgba(192,192,192,0.0001)")
                    .attr("stroke-width", "24")
                    .attr("stroke-linejoin", "round")
                    .attr("stroke-linecap", "round")
                    .attr("d", function () {
                    // @ts-ignore
                    return d3_1.line()
                        .defined(function (_a) {
                        var value = _a.value;
                        return typeof value === "number";
                    })
                        .x(function (_a) {
                        var x = _a.x;
                        return x;
                    })
                        .y(function (_a) {
                        var y = _a.y;
                        return y;
                    })(data);
                });
            });
        });
        this.seriesGroup
            .selectAll("." + markersCls)
            .data(series)
            .join("g")
            .attr("class", function (_, i) { return markersCls + " " + classPrefix + "-chart-series-" + i; })
            .attr("data-z-index", function (_, i) { return series.length - i - 1; });
        var maxSerieIndex = series.length;
        for (var start = 0; start <= maxSerieIndex; start++) {
            this.seriesGroup
                .selectAll("." + classPrefix + "-chart-series-" + start)
                .raise();
        }
    };
    return Area;
}(line_1.Line));
exports.Area = Area;
//# sourceMappingURL=area.js.map